import { ReactNode } from 'react';

import { ToggleSwitch } from '../../../../../../components/toggle-switch';

import './styles.scss';

interface ToggleFieldRowProps {
  label: string;
  description?: string;
  isOn: boolean;
  onToggle: (value: boolean) => void;
  children?: ReactNode;
}

export const ToggleFieldRow = ({
  label,
  description,
  isOn,
  onToggle,
  children,
}: ToggleFieldRowProps) => {
  return (
    <div className="toggle-field-row">
      <div className="toggle-field-header">
        <div className="toggle-field-header-toggle">
          <ToggleSwitch isOn={isOn} setIsOn={onToggle} />
        </div>
        <div className="toggle-field-info">
          <span className="toggle-field-label">{label}</span>
          {description && <span className="toggle-field-description">{description}</span>}
        </div>
      </div>
      {isOn && children && <div className="toggle-field-content">{children}</div>}
    </div>
  );
};
